import type { Store } from '@ps/web-core-store';
import { trackingTranslation } from '@ps/web-shared-components';
import type { InjectedValidatorProps } from '@ps/web-shared-components';
import { useStore } from 'react-redux';

export const useErrorLabels = (
  validationErrors: InjectedValidatorProps['validationErrors'] = []
) => {
  const store = useStore() as Store;

  return validationErrors
    .filter((error) => !error.valid)
    .map(({ message }) => trackingTranslation(message, store))
    .filter(Boolean) as string[];
};

export default useErrorLabels;
